import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Home from './components/home'


const TheExperts = () => {
  return (
    <div>
         <Routes>
        <Route path="/#Home" element={<Home/>}/>
        <Route path="/*" element={<Home/>}/>
        <Route path="/Home" element={<Home/>}/>  
        <Route path="/" element={<Home/>}/>
        </Routes>
    </div>
  )
}

export default TheExperts